import React from 'react';
import { PermissionCategory } from './models/PermissionCategoryViewModel';

export type PermissionCheckArg = {
  group: string;
  permission: string;
};

export interface AssignedPermissions {
  module: string;
  permission: string;
}

interface PCContextType {
  assignedPermissions: AssignedPermissions[];
  permissionCategories: PermissionCategory[];
  totalPermissions: number;
  toggleAllPermissions: () => void;
  onAddPermissions: () => void;
  onGroupChecked: (group: string) => void;
  onPermissionChecked: (arg: PermissionCheckArg) => void;
  onPermissionDialogToggle: (isOpen?: boolean) => void;
  isLoading?: boolean;
  isEdit?: boolean;
  searchedText: string;
  onSearch: (value: string) => void;
}

export const defaultPermissionContext = {
  isLoading: false,
  isEdit: false,
  assignedPermissions: [],
  permissionCategories: [],
  totalPermissions: 0,
  searchedText: '',
  onPermissionChecked: () => {},
  onPermissionDialogToggle: () => {},
  onGroupChecked: () => {},
  toggleAllPermissions: () => {},
  onAddPermissions: () => {},
  onSearch: () => {},
};

export const PermissionCategoryContext = React.createContext<PCContextType>({
  ...defaultPermissionContext,
});

export const usePermissionCategoryContext = () =>
  React.useContext(PermissionCategoryContext);
